import axios from 'axios'
import React from 'react'
import DropDownCard from './DropDownCard/DropDownCard'
import './workflow-drop-down.css'
import { baseUrl } from '../assets/Animations'
import AreYouSureYouWantToDeleteThisWorkflow from './AreYouSureYouWantToDeleteThisWorkflow/AreYouSureYouWantToDeleteThisWorkflow'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const WorkflowDropDown = (props) => {
    const [templates, setTemplates] = React.useState([])
    const [areYouSure, setAreYouSure] = React.useState(false)

    React.useEffect(() => {
        console.log(areYouSure)
    }, [areYouSure])

    React.useEffect(() => {
        axios.get(`${baseUrl}/templates`, myHeader)
        .then((res) => {
            setTemplates(res.data)
        })
        .catch((err) => {
            console.log(err)
        })
    },[])
    const closeDropDown = (tar) => {
        if(tar === "workflow-dropdown-background") {
            props.toggleWorkflowDropdown()
        }
    }
    const openTemplate = () => {
        props.setWorkflowTemplateModal2023({
            todoId: Math.random().toString(16).slice(2),
            todoName: "Customize Workflow",
            todoDescription: "Notes...",
            todoDueDate: new Date(),
            todoAlarm: false,
            todoOwner: '',
            whichList: 'todos',
            todoSubtasks: [],
        })
        props.toggleWorkflowDropdown()
    }
    const deleteATemplate = (id) => {
        console.log(id)
        axios.delete(`${baseUrl}/templates/${id}`, myHeader)
        .then((res) => {
            let arrTemps = templates
            for(let i = 0; i < templates.length; i++) {
                if(templates[i].todoId === id) {
                    arrTemps.splice(i, 1)
                    setTemplates([...arrTemps])
                    setAreYouSure(false)
                }
            }
        })
        .catch((err) => {
            console.log(err)
        })
    }
    if(templates.length > 0) {
        return (
            <div className="workflow-dropdown-background" id="workflow-dropdown-background" onClick={(e) => closeDropDown(e.target.id)}>
                {areYouSure && <AreYouSureYouWantToDeleteThisWorkflow deleteATemplate={deleteATemplate} templateId={areYouSure} setAreYouSure={setAreYouSure} />}
                <div className="dropdown-list">
                    {templates.map(workflow => <DropDownCard key={workflow.todoId} todoId={workflow.todoId} name={workflow.todoName} setAreYouSure={setAreYouSure} openANewWorkflow={props.openANewWorkflow} setEditWorkflow={props.setEditWorkflow} />)}
                    <DropDownCard name={'+ Create Template'} openTemplate={openTemplate} create={true} />
                </div>
            </div>
        )
    } else {
        return (
            <div className="workflow-dropdown-background" id="workflow-dropdown-background" onClick={(e) => closeDropDown(e.target.id)}>
                <div className="dropdown-list">
                    <DropDownCard name={'Loading Templates...'} />
                    <DropDownCard name={'+ Create Template'} openTemplate={openTemplate} create={true} />
                </div>
            </div>
        )
    }
}

export default WorkflowDropDown;